<script>
import { mapGetters, mapState } from 'vuex'
import Retirement from '@components/retirement/retirement.vue'
import HtmlOnly from '@components/html-only/html-only.vue'

import isEmpty from 'lodash/isEmpty'
import NewTestimonials from '../components/testimonials/newTestimonials.vue'
import NewSignUp from '@components/signUp/new-sign-up.vue'
import NewHeroHome from '../components/hero/new-hero-home.vue'

export default {
  data () {
    return {
      toggleCard: false
    }
  },
  name: 'Home',
  created () {
    this.$store.commit('setFromChallenge', false)
    if (window.ga) {
      window.ga('set', 'page', '/')
      window.ga('send', 'pageview')
    }
  },
  computed: {
    ...mapState(['user', 'settings']),
    ...mapGetters(['home']),
    loaded () {
      return !isEmpty(this.home)
    }
  },
  components: {
    Retirement,
    HtmlOnly,
    NewTestimonials,
    NewSignUp,
    NewHeroHome
  },
  methods: {}
}
</script>

<template>
  <div v-if="loaded">
    <template v-for="component in home.components">
      <div :key="component._key" v-if="component._type === 'newHero'">
        <NewHeroHome :component="component" />
      </div>
      <div :key="component._key" v-if="component._type === 'pricing'">
        <NewSignUp :component="component" />
      </div>
      <div :key="component._key" v-if="component._type === 'newTestimonials'">
        <NewTestimonials :component="component" />
      </div>
      <div :key="component._key" v-if="component._type === 'retirement'">
        <Retirement :component="component" />
      </div>
      <div :key="component._key" v-if="component._type === 'htmlOnly'">
        <HtmlOnly :component="component" />
      </div>
    </template>
  </div>
</template>

<style lang="scss">
  .block-three {
    background: linear-gradient(rgba(130,129,183,0.9), rgba(130,129,183,0.9)), var(--background-img) no-repeat center center;
    background-size: cover;
    color: white;
    .carousel img {
      height: auto;
      width: 255px;
    }
    @media (max-width: 992px) {
      .details {
        margin-left: unset;
        padding-left: unset;
        margin-right: unset;
        width: 100%;
        text-align: -webkit-center;
      }
      .carousel-container {
        flex-direction: column-reverse;
        align-items: center;
      }
      .carouse {
        outline: 0;
        max-width:150px;
        margin:auto;
        margin-top:1rem;
        img {
          height: 300px;
          width: auto;
        }
      }
    }
  }
  .block-four {
    -webkit-font-smoothing: antialiased;
    line-height: 1.5;
    font-family: 'Montserrat', sans-serif;
    width: 100vw;
    position: relative;
    background-image: var(--background-img);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: left top;
    #plan-container {
      .signup-arrow {
        transition-timing-function: ease;
        z-index: 8;
        margin-top: 15px;
        svg {
          color: black;
          float: right;
          margin-right: 30px;
          margin-top: -9px;
          border-radius: 3px;
          border-style: solid;
          border-width: 2px;
          width: 40px;
          background-color: white;
          border-color: rgb(175, 175, 175);
          cursor: pointer;
          &:hover { background-color: gray;}
        }
      }
      .signup-popover-enter {
        opacity: 0;
        transform: rotateY(90deg);
      }
      .signup-popover-enter-to {
        opacity: 1;
        transform: rotateY(0deg);
      }
      .signup-popover-enter-active {
        transition: opacity, transform 400ms ease-out;
      }
      .signup-popover-leave-active {
        transition: opacity 300ms ease-in;
      }
      .signup-popover-leave-to {
        opacity: 0;
      }
      .card-popover-enter {
        opacity: 0;
        transform: rotateY(90deg);
      }
      .card-popover-enter-to {
        opacity: 1;
        transform: rotateY(0deg);
      }
      .card-popover-enter-active {
        transition: opacity, transform 400ms ease-out;
      }
      .card-popover-leave-active {
        transition: opacity 300ms ease-in;
      }
      .card-popover-leave-to {
        opacity: 0;
      }
      .subscriptionChoose {
        padding: 2rem;
        border-radius: 20px;
        width: 600px;
        p { font-weight: bold; font-size: 1.2rem;}
      }
      .sign-up {
        flex-direction: column;
        display: inline-flex;
        justify-content: space-between;
        padding: 10px;
        width: 100%;
        .signup-email {
          outline: 0;
          display: inline-flex;
          justify-content: center;
          align-items: center;
          padding: 4px 8px;
          border-radius: 3px;
          color: #fff;
          border-radius:8px;
          width: 100%;
          height: 40px;
          margin-top: 2.5px;
          margin-bottom: 2.5px;
          text-transform: none;
          cursor: pointer;
          svg {
            margin-right: 5px;
          }
          &:disabled { cursor: not-allowed }
        }
      }
      .pay {
        outline: 0;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        padding: 4px 8px;
        border-radius: 3px;
        background-color: var(--secondary-color);
        color: #fff;
        border-radius:8px;
        width: 160px;
        height: 40px;
        margin-top: 2.5px;
        margin-bottom: 2.5px;
        cursor: pointer;
        svg {
          margin-right: 5px;
        }
        &:hover {
          background-color: var(--primary-color);
          &:disabled { cursor: not-allowed; background-color: var(--secondary-color);}
        }
      }
      .signup-form {
        margin: 10px;
        padding: 1rem;
        height: fit-content;
        border-radius: 20px;
        background-color: white;
        width: 400px;
        p { font-weight: bold; font-size: 1.2rem;}
      }
      @media (max-width: 992px) {
        flex-direction: column-reverse;
        .subscriptionChoose { width: -webkit-fill-available; padding: 1rem; }
        .signup-form { width: 350px; }
      }
      @media screen and (max-width:768px){
        background:#fff;
      }
    }
  }
  .block-five {
    line-height: 1.5;
    display: flex;
    justify-content: center;
    padding-top: 60px;
    padding-bottom: 60px;
    .block-five-container {
      display: flex;
      flex-direction: column;
      text-align: center;
      justify-content: center;
      align-content: center;
      max-width: 80%;
      .lower-part {
        display: flex;
        flex-wrap: wrap;
        margin-right: -15px;
        margin-left: -15px;
        .column { flex: 0 0 25%; max-width: 25%; position: relative;
          width: 100%;
          min-height: 1px;
          padding-right: 15px;
          padding-left: 15px;
          img { border-radius: 1rem; max-width: 100%;}
        }
      }
    }
    .upper-part {
      font-family: 'Montserrat', sans-serif;
      h2 {
        font-weight: 600;
      }
      button { text-transform: uppercase; width: 60%;}
    }
    .goToForm {
      margin-top: 20px;
      text-align: center;
      letter-spacing: 2px;
      width: 40%;
      min-height: 60px;
      border-radius:10px;
      outline: 0;
      background-color: var(--secondary-color);
      text-transform: uppercase;
      color: white;
      -webkit-font-smoothing: antialiased;
      &:hover {
        background-color: var(--primary-color)
      }
    }
    @media (max-width: 769px) {
      .block-five-container {
        .lower-part {
          flex-direction: column;
          .column { max-width: unset; padding-top: 10px; padding-bottom: 10px;}
        }
      }
    }
  }
  .block-six {
    background-image: var(--background-img);
    background-repeat: no-repeat;
    .container {
      height: 100%;
      .row {
        height: 100%;
      }
    }
    @media (max-width: 769px) {
      height: 750px;
      .carousel-wrapper {
        width: 100%;
        img {
          width: 100%;
        }
      }
    }
  }
  .block-seven {
    background-color: #efefef;
  }
</style>
